/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${colors.gullGrey};
  border-radius: 4px;
  background-color: ${({ isDisabled }) => (isDisabled ? colors.colorReadonly : colors.white)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'initial')};
  min-height: 38px;
  .circle {
    height: 25px;
    width: 28px;
    background-color: ${({ mainColor }) => mainColor};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .circle-text {
      color: ${colors.white};
      font-family: ${fonts.default};
      font-size: 18px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 21px;
      position: relative;
      top: 2px;
    }
  }

  &.has-focus {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .select-search {
    min-height: 38px;
    height: 100%;
    @media ${device.sm} {
      flex: 0 0 76%;
    }
    @media ${device.md} {
      flex: 0 0 79%;
    }
    @media ${device.lg} {
      flex: 0 0 83%;
    }
    @media ${device.xl} {
      flex: 0 0 83%;
    }

    .select-search__value {
      border: none !important;
      height: 100%;
      input {
        border: none !important;
        padding: ${({ isColor, selectedAdvisor }) =>
          isColor ? '5px 20px' : selectedAdvisor ? '5px 37px 0' : '5px 14px'};
        &::placeholder {
          color: ${colors.suvaGrey};
          font-family: ${fonts.roboto};
          font-size: ${fontSizes.xs}px;
          letter-spacing: 0;
          line-height: 16px;
        }
      }
    }
    .select-search__select {
      z-index: 9999;
      background-color: ${colors.white};
      border: 1px solid ${colors.gullGrey};
      border-radius: 0 0 4px 4px;
      width: 100%;
      border-top: none;
      left: 0;
      position: absolute;
    }

    .select-search__options {
      list-style-type: none;
      padding: 0;
      overflow-y: scroll;
      height: auto;
      max-height: 280px;
      .select-search__not-found {
        background-color: transparent;
        border: none;
        color: ${colors.zambezi};
        font-family: ${fonts.medium};
        font-size: ${fontSizes.sm}px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 16px;
        width: 100%;
        height: 28px;
        display: flex;
        padding: 17px 29px 21px 17px;
        align-items: center;
        justify-content: center;
      }
      .select-search__row {
        margin-bottom: 10px;
        .select-search__option {
          background-color: transparent;
          border: none;
          color: ${colors.zambezi};
          font-family: ${fonts.roboto};
          font-size: ${fontSizes.xs}px;
          letter-spacing: 0;
          line-height: 16px;
          width: 100%;
          height: 28px;
          display: flex;
          padding: 17px 29px 21px 17px;
          align-items: center;
          &:hover {
            background-color: ${colors.whiteSmoke};
            color: ${colors.black};
          }
        }
      }
    }
  }
  .icons-wrapper {
    flex: 0 0 15%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-right: 7px;
  }

  .selected-color {
    height: 13px;
    width: 13px;
    background-color: ${({ selectedColor }) => `${selectedColor}`};
    position: absolute;
    top: 33px;
    left: 6px;
  }

  .selected-advisor {
    height: 25px;
    width: 28px;
    background-color: ${({ mainColor }) => mainColor};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.white};
    font-family: ${fonts.default};
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 0;
    position: absolute;
    top: 33px;
    left: 6px;
    text-transform: uppercase;
  }

  svg {
    fill: ${colors.black};
  }
  .caret-down-icon {
    pointer-events: none;
    height: 20px;
    width: 17px;
  }

  .caret-up-icon {
    pointer-events: initial;
    height: 20px;
    width: 17px;
  }

  .search-icon {
    height: 20px;
    width: 30px;
  }

  .clear-icon {
    height: 15px;
    width: 18px;
    cursor: pointer;
    margin-right: 2px;
  }

  &.error {
    background-color: ${colors.tutu};
    border: 1px solid ${colors.error};
    .select-search {
      .select-search__value {
        input {
          &::placeholder {
            color: ${colors.textError};
          }
        }
      }
      .select-search__select {
        background-color: ${colors.tutu};
        border: 1px solid ${colors.error};
        border-top: none;
      }
    }
    svg {
      fill: ${colors.error};
    }
  }
`;

const ListColor = styled.div`
  height: 13px;
  width: 13px;
  background-color: ${({ color }) => `${color}`};
  margin-right: 5px;
`;

export { DropdownWrapper, ListColor };
